import { supabase } from './supabaseClient';

/**
 * Start Stripe checkout and redirect the user
 * @param {function} setLoading - optional setter for loading state
 * @param {string} promoCode - optional promo/discount code
 */
export const handleUpgrade = async ({ setLoading, promoCode } = {}) => {
  try {
    if (setLoading) setLoading(true);

    const { data: { user }, error: userError } = await supabase.auth.getUser();
    if (userError || !user) throw new Error(userError?.message || 'Not signed in');

    const body = { userId: user.id, email: user.email };
    if (promoCode) body.promoCode = promoCode;

    const res = await fetch('/api/create-checkout-session', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const { error } = await res.json();
      throw new Error(error || 'Unable to start checkout.');
    }

    const { url } = await res.json();
    window.open(url, '_blank', 'noopener,noreferrer');
  } catch (err) {
    console.error('🔥 Upgrade error:', err);
    alert(err.message);
  } finally {
    if (setLoading) setLoading(false);
  }
};
